class BootstrapService {
    constructor($window) {
        this._data = $window.wowBootstrap || {};

        // A map of objects which are bootstrapped
        this.bootstrapped = {
            Config: 'ConfigRequest',
            Settings: 'SettingRequest',
            Shopper: 'ShopperRequest',
            ShopperDetails: 'ShopperDetailsRequest',
            ShopperPreferences: 'BasicShopperPreferencesRequest',
            Categories: 'ListAllPiesCategoriesWithSpecialsRequest',
            RootCategories: 'ListTopLevelPiesCategories',
            Trolley: 'TrolleyRequest',
            DeliveryInfo: 'GetDeliveryInfoRequest',
            SpecialsGroups: 'SpecialsGroupListForShopRequest',
            SpecialsCategories: 'ListCategoriesForSpecialsRequest',
            RecipeCategories: 'ListRecipeCategoriesRequest',
            SavedLists: 'ListSavedListsRequest',
            SuggestedLists: 'ListSuggestedListsRequest',
            PastShops: 'ListPastShopsRequest',
            SearchPhraseActions: 'ListSearchPhraseActionsRequest',
            Panels: 'PanelsRequest',
            Subscriptions: 'SubscriptionsRequest',
        };
    }

    getBootstrappedData(key) {
        return this._data[key];
    }

    isBootstrapped(key) {
        return key in this._data && !!this._data[key];
    }

    getBootstrappedDataIfPresent(key) {
        return this.isBootstrapped(key)
            ? this.getBootstrappedData(key)
            : null;
    }
}

BootstrapService.$inject = ['$window'];

module.exports = { BootstrapService };



// WEBPACK FOOTER //
// ./src/common/bootstrap/bootstrap.service.js